import { render, staticRenderFns } from "./Delete_Item.vue?vue&type=template&id=034c93bd&scoped=true"
import script from "./Delete_Item.vue?vue&type=script&lang=js"
export * from "./Delete_Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c93bd",
  null
  
)

export default component.exports